// extracted by mini-css-extract-plugin
export default {"wrapBtn":"LanguageSwitcher_wrapBtn__Kmww5","btn":"LanguageSwitcher_btn__8VJAn"};